import React, { useEffect, useRef, useState } from "react";
import "react-responsive-modal/styles.css";
import leftArrow from "../../assets/Images/left-arrow.png";
import rightArrow from "../../assets/Images/right-arrow.png";
import "./issue.css";
import { DPR_API } from "../../services/apiCalls/dprApiCalls";

export default function RiskResgisterList({ subId }) {
  const [issueList, setIssueList] = useState([]);

  const getIssueData = async () => {
    const state = JSON.parse(localStorage.getItem("state"));
    setCurrentPage(1);
    let obj = {
      UserID: state.user.user_id,
      TaskID: subId,
    };
    const risk = await DPR_API.GetIssueAllocationDetails(obj);
    if (risk.status === 200) {
      setIssueList(risk.IssueList);
    } else {
      setIssueList([]);
    }
  };

  useEffect(() => {
    getIssueData();
  }, []);

  const handleRowSelect = (id) => {
    // let newSelectedRows = [...selectedRows];
    // if (newSelectedRows.includes(id)) {
    //     newSelectedRows = newSelectedRows.filter((rowId) => rowId !== id);
    // } else {
    //     newSelectedRows.push(id);
    // }
    // setSelectedRows(newSelectedRows);
    // setSelectAll(newSelectedRows.length === data.length);
  };

  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 10;

  const totalPages = Math.ceil(issueList.length / rowsPerPage);

  const handleClick = (page) => {
    setCurrentPage(page);
  };

  const paginatedData = issueList.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage
  );

  return (
    <React.Fragment>
      <div className="table-container" style={{width:'100%'}}>
        <table className="custom-table">
          <thead className="table-header">
            <tr>
              <th>Sr No</th>
              <th>Project Name</th>
              <th>Product Category</th>
              <th>Project Location</th>
              <th>Issue Description</th>
              <th>Impact Level</th>
              <th>Issue Status</th>
              <th>Created Date</th>
            </tr>
          </thead>
          <tbody>
            {paginatedData.map((row, index) => (
              <tr key={index}>
                <td>{index + 1 + (currentPage - 1) * 10}</td>
                <td id="elps" title={row.ProjectName}>
                  {row.ProjectName}
                </td>
                <td id="elps" title={row.ProductCategory}>
                  {row.ProductCategory ? row.ProductCategory : "-"}
                </td>
                <td id="elps" title={row.ProjectLocation}>
                  {row.Location ? row.Location : "-"}
                </td>
                <td id="elps" title={row.IssueDescription}>
                  {row.IssueDescription ? row.IssueDescription : "-"}
                </td>

                <td id="elps" title={row.ImpactLevel}>
                  {row.ImpactLevel ? row.ImpactLevel : "-"}
                </td>
                <td id="elps" title={row.IssueStatus}>
                  {row.IssueStatus ? row.IssueStatus : "-"}
                </td>
                <td>{new Date(row?.CreatedOn).toLocaleDateString('en-GB')}</td>
              </tr>
            ))}
          </tbody>
        </table>
        <div
          className="pagination"
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "10px 15px",
          }}
        >
          <div style={{ fontSize: "14px", whiteSpace: "nowrap" }}>
            Showing{" "}
            {Math.min((currentPage - 1) * rowsPerPage + 1, issueList.length)} to{" "}
            {Math.min(currentPage * rowsPerPage, issueList.length)} of{" "}
            {issueList.length} entries
          </div>

          <div
            className="pagination-buttons"
            style={{
              fontSize: "14px",
              display: "flex",
              justifyContent: "flex-end",
              width: "100%",
              gap: "5px",
            }}
          >
            <button
              onClick={() => handleClick(Math.max(1, currentPage - 1))}
              disabled={currentPage === 1}
              style={{
                background: "none",
                border: "none",
                cursor: currentPage === 1 ? "not-allowed" : "pointer",
              }}
            >
              <img
                src={leftArrow}
                alt="Previous"
                height="11px"
                width="7px"
                style={{ opacity: currentPage === 1 ? 0.5 : 1 }}
              />
            </button>

            {[...Array(totalPages)].map((_, i) => (
              <button
                key={i}
                onClick={() => handleClick(i + 1)}
                style={{
                  background: currentPage === i + 1 ? "#00B69B" : "transparent",
                  color: currentPage === i + 1 ? "#fff" : "#000",
                  border: "none",
                  borderRadius: "50%",
                  width: "30px",
                  height: "30px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  cursor: "pointer",
                }}
              >
                {i + 1}
              </button>
            ))}

            <button
              onClick={() => handleClick(Math.min(totalPages, currentPage + 1))}
              disabled={currentPage === totalPages}
              style={{
                background: "none",
                border: "none",
                cursor: currentPage === totalPages ? "not-allowed" : "pointer",
              }}
            >
              <img
                src={rightArrow}
                alt="Next"
                height="11px"
                width="7px"
                style={{
                  opacity: currentPage === totalPages ? 0.5 : 1,
                }}
              />
            </button>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}
